import React, { useState } from 'react';
import StatusDot from './StatusDot';
import useUser from '../hooks/useUser';

export default function Topbar({ domain = 'ops', domainLabel = 'OPS', kpis = [], onSearch, kiOpen, onKiToggle, onSettingsOpen, onBillingOpen, onMenuToggle }) {
  const accent = `var(--accent-${domain})`;
  const { user } = useUser();
  const [searchExpanded, setSearchExpanded] = useState(false);

  return (
    <header className="eco-topbar">
      {/* Left: Hamburger (mobile) + Domain label */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--gap-sm)', minWidth: 0 }}>
        {onMenuToggle && (
          <button className="hamburger-btn" onClick={onMenuToggle} aria-label="Menu">
            &#9776;
          </button>
        )}
        <span style={{
          fontWeight: 700,
          fontSize: 'var(--font-size-lg)',
          color: accent,
          letterSpacing: '1px',
          textTransform: 'uppercase',
          whiteSpace: 'nowrap',
        }}>
          {domainLabel}
        </span>
        <span className="hide-mobile" style={{ color: 'var(--text-muted)', fontSize: 'var(--font-size-xs)' }}>
          devbox
        </span>
      </div>

      {/* Center: Status pills (hidden on mobile) */}
      <div className="eco-topbar__kpis hide-mobile">
        {kpis.map((kpi, i) => (
          <div key={i} className="pill">
            <StatusDot status={kpi.status} size={6} />
            <span>{kpi.label}</span>
            {kpi.value && (
              <span style={{ fontFamily: 'var(--font-mono)', fontWeight: 500 }}>{kpi.value}</span>
            )}
          </div>
        ))}
      </div>

      {/* Right: Search + Tokens + KI + Settings */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--gap-sm)', flexShrink: 0 }}>
        {onSearch && (
          <>
            {/* Desktop search */}
            <input
              className="input eco-topbar__search-desktop"
              style={{ width: 180, fontSize: 'var(--font-size-xs)' }}
              placeholder="Search..."
              onChange={e => onSearch(e.target.value)}
            />
            {/* Mobile search toggle */}
            <button
              className="hamburger-btn eco-topbar__search-toggle"
              onClick={() => setSearchExpanded(!searchExpanded)}
              aria-label="Search"
              style={{ fontSize: 14 }}
            >
              &#128269;
            </button>
          </>
        )}
        {/* Token Balance */}
        {user && (
          <button
            onClick={onBillingOpen}
            className="eco-topbar__token-btn"
            title={user.unlimited ? 'Admin — Unlimited Tokens' : `${user.balance} Tokens verbleibend`}
          >
            {user.unlimited ? '\u221E' : user.balance}
          </button>
        )}
        <button
          onClick={onKiToggle}
          className="eco-topbar__ki-btn"
          style={{
            border: kiOpen ? '1px solid var(--accent-comm)' : '1px solid var(--border)',
            background: kiOpen ? 'rgba(187,154,247,0.15)' : 'var(--bg-tertiary)',
            color: kiOpen ? 'var(--accent-comm)' : 'var(--text-secondary)',
          }}
          title="KI-Assistent"
        >
          KI
        </button>
        <button
          onClick={onSettingsOpen}
          className="btn eco-topbar__settings-btn"
          style={{ padding: '4px 8px', fontSize: 14 }}
          title="Einstellungen"
        >
          &#9881;
        </button>
      </div>

      {/* Mobile expanded search bar */}
      {searchExpanded && onSearch && (
        <div className="eco-topbar__search-expanded">
          <input
            className="input"
            style={{ flex: 1, fontSize: 16 }}
            placeholder="Search..."
            onChange={e => onSearch(e.target.value)}
            autoFocus
          />
          <button
            className="btn btn-compact"
            onClick={() => setSearchExpanded(false)}
          >
            &times;
          </button>
        </div>
      )}
    </header>
  );
}
